import React from 'react';
import { Typography, Button } from '@hpstellar/core';

import HyperLink from '../../shared/components/hyperlink';
import HeroBanner from '../../hero-banner/hero-banner';

const isNonEmptyString = str => typeof str === 'string' && str.trim().length > 0;

export default ({ dlpBanner, css, renderCSS, shouldRenderCSS }) => {
    let { bannerImage, disableImageBanner, bannerText, bannerAlt, bannerTitle, ctaLink, ctaText } = dlpBanner || {};
    const imageSrc = bannerImage.url || bannerImage.src;
    const shouldRenderBannerImage = !disableImageBanner && bannerImage && isNonEmptyString(imageSrc);

    const hasCTA = isNonEmptyString(ctaLink);
    const hasBannerText = isNonEmptyString(bannerText);
    const hasCTAText = isNonEmptyString(ctaText);
    const hasBannerAlt = isNonEmptyString(bannerAlt);
    const hasBannerTitle = isNonEmptyString(bannerTitle);

    const bannerImageElement = (
        <img
            className="hero-image"
            src={imageSrc}
            alt={hasBannerAlt ? bannerAlt : null}
            title={hasBannerTitle ? bannerTitle : null}
        />
    );

    return (
        shouldRenderBannerImage && (
            <div className="dlp-banner-container">
                {renderCSS(css)}
                <HeroBanner className="featured-product-banner dlp-banner">
                    {bannerImage &&
                        (hasCTA ? <HyperLink to={ctaLink}>{bannerImageElement}</HyperLink> : bannerImageElement)}
                    <div className="dlp-banner-text-container">
                        {hasBannerText && (
                            <Typography variant="titleL" tag="h2" className="dlp-banner-text">
                                {bannerText}
                            </Typography>
                        )}
                        {hasCTA && hasCTAText && (
                            <Button className="dlp-cta" to={ctaLink} variation="primary" size="small">
                                {ctaText}
                            </Button>
                        )}
                    </div>
                </HeroBanner>
            </div>
        )
    );
};
